<template>
    <div class="legal-cases">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">Legal Cases</h3> -->
                <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Legal Cases
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_legal_cases_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="_gAuth.isAppSas()">
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        prop="legal_case_case_type"
                        label="Case Type"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="text-break top-line">{{ scope.row.legal_case_case_type }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="legal_case_plaintiff"
                        label="Plaintiff"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="text-break top-line">{{ scope.row.legal_case_plaintiff || '-' }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Solicitor/Tel"
                        min-width="180"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="mb-0 top-line">{{ scope.row.legal_case_solicitor_name || '-' }}</p>
                            <p class="text-uppercase bottom-line mb-0">{{ scope.row.legal_case_solicitor_tel }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No Legal Cases recorded</p>
            </div>
            </div>
            <div v-else>
                <div v-if="normalizedLegalCasesSummary.length > 0" class="rounded-bottom">
                    <el-table :data="normalizedLegalCasesSummary" style="width: 100%">
                        <el-table-column
                            prop="case_type"
                            label="Case Type"
                            min-width="150"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="text-break top-line">{{ scope.row.case_type || '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="plaintiff"
                            label="Plaintiff"
                            min-width="150"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="text-break top-line">{{ scope.row.plaintiff || '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Amount"
                            min-width="120"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="text-break top-line">{{ formatCaseAmount(scope.row, scope.$index) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Subject Comment"
                            min-width="120"
                            width="auto">
                            <template slot-scope="scope">
                                <p class="text-break top-line">{{ scope.row.subject_comment || '-' }}</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-else class="bg-light p-3 text-center rounded-bottom">
                    <p class="text-xs">No Legal Cases recorded</p>
                </div>
            </div>
        </b-card>
      <LegalCasesModal
    :legal-cases="legalCases" 
    :reserve-price="reservePrice"
    :legal-cases-resp="legalCasesResp"
    :legal-cases-summary="legalCasesSummary"
    :show_legal_cases_full_view.sync="modals.show_legal_cases_full_view"
/>
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui'
    import { axios, getHeader } from '@/assets/js/httpImports.js'
    import LegalCasesModal from '@/views/CustomerProfile/CustomerModals/LegalCasesModal.vue'

    export default {
        name: 'legal-cases',
        props: [
        'legal-cases', 
        'reservePrice',
        'legalCasesResp',
        'legalCasesSummary',
       ],
        components: {
            LegalCasesModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.legalCases,
                modals: {
                  show_legal_cases_full_view: false
                }
            }
        },
        computed: {
          // Normalize legalCasesSummary for consistent handling
          normalizedLegalCasesSummary() {
              if (Array.isArray(this.legalCasesSummary)) {
                  return this.legalCasesSummary;
              } else if (this.legalCasesSummary && typeof this.legalCasesSummary === 'object') {
                  // If it's a single object, wrap it in an array
                  return [this.legalCasesSummary];
              }
              return [];
          }
       },
      methods: {
      // Format case amount - use reserve price for "PROCLAIMATION OF SALE" cases
        formatCaseAmount(legalCase) {      
            // First check if there's an amount in the legalCase object
            if (legalCase.amount && legalCase.amount > 0) {
                return `RM ${this.formatReservePrice(legalCase.amount)}`;
            }
            
            if (legalCase.case_amt && legalCase.case_amt > 0) {
                return `RM ${this.formatReservePrice(legalCase.case_amt)}`;
            }
            
            // Find matching case in legalCasesResp by case type and plaintiff
            if (this.legalCasesResp && Array.isArray(this.legalCasesResp)) {
                const matchingCase = this.legalCasesResp.find(respCase => 
                    respCase.title === legalCase.case_type && 
                    respCase.plaintiff === legalCase.plaintiff
                );
                
                if (matchingCase && matchingCase.reserve_price && matchingCase.reserve_price > 0) {
                    return `RM ${this.formatReservePrice(matchingCase.reserve_price)}`;
                }
            }
            
            return '-';
        },
        
        formatReservePrice(price) {
            if (!price) return "0";
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    //      mounted() {
    //    console.log('legalCasesResp:', this.legalCasesResp)
    //  }
    }
</script>